export default __webpack_public_path__ + "static/media/share.712cef5c.svg";